import { defineStore } from 'pinia';
import { ref } from 'vue';
import { isEqual } from 'lodash';

import type { TripOverviewNofication } from '../models';

export const useTripOverviewNotificationsStore = defineStore(
  'TripOverviewNotificationsStore',
  () => {
    // State
    const notifications = ref<TripOverviewNofication[]>([]);

    // Actions
    function addNotification(notification: TripOverviewNofication): void {
      notifications.value.push(notification);
    }

    function removeNotification(notification: TripOverviewNofication): void {
      notifications.value = notifications.value.filter(
        (n) => !isEqual(n, notification)
      );
    }

    function clearNotifications(): void {
      notifications.value = [];
    }

    return {
      // State
      notifications,
      // Actions
      addNotification,
      removeNotification,
      clearNotifications,
    };
  }
);
